



























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import API from '@/utils/api'
import { Player } from '@/models/Player'
@Component({
  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },
})
export default class PlayerStat extends Vue {
  loading: boolean = true
  player: Player | null = null
  stats: any[] = []
  headers: any[] = []
  season_stats: any[] = []
  season_headers: any[] = []
  get filteredHeaders() {
    return this.headers.filter((header: any) => !header.hide)
  }
  loadPlayerStats() {
    this.loading = true
    return API.loadPlayerStats(this.$props.playerId)
      .then((r) => {
        this.player = r.data.player
        this.stats = r.data.stats
        this.headers = r.data.headers
        this.season_headers = r.data.season_headers || []
        this.season_stats = r.data.season_stats || []
      })
      .catch((err) => {})
      .finally(() => {
        this.loading = false
      })
  }
  mounted() {
    this.loadPlayerStats()
  }
  @Watch('playerId')
  onPlayerIdChanged(newPlayerId: any, oldPlayerId: any) {
    if (newPlayerId !== oldPlayerId) {
      this.loadPlayerStats()
    }
  }
}
